<template>
    <div id="app">
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
        <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
    </button>-->
                <h1 class="activeTriggerHeader">  ACTIVE TRIGGERS</h1>
                <h1 class="activeTriggerHeader">  {{liveTriggers}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toLiveTriggers()">Go To Active Triggers</button>
                </div>
            </div>
        </div>
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
        <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
    </button>-->
                <h1 class="dueLiveTriggerHeader">  DUE LIVE TRIGGERS</h1>
                <h1 class="dueLiveTriggerHeader">  {{dueLiveTriggers}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toDueLiveTriggers()">Go To Due Live Triggers</button>
                </div>
            </div>
        </div>
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
        <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
    </button>-->
                <h1 class="expiredTriggerHeader">  EXPIRED TRIGGERS</h1>
                <h1 class="expiredTriggerHeader">  {{expiredTriggers}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toExpiredTriggers()">Go To Expired Triggers</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import urls from '../common/urls';
    import apis from '../common/network';

    export default {
        data() {
            return {
              
                liveTriggers: "",
                dueLiveTriggers: "",
                expiredTriggers: "",
            };
        },
        methods: {
            toLiveTriggers(args) {
                this.$router.push({ name: 'Live' });
            }, toDueLiveTriggers(args) {
                this.$router.push({ name: 'Due Live' });
            }, toExpiredTriggers(args) {
                this.$router.push({ name: 'Expired' });
            },
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/GroupCounts`).then(it => {
                    this.liveTriggers = it.data.active;
                    this.dueLiveTriggers = it.data.dueLive;
                    this.expiredTriggers = it.data.expired;

                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },
        },
        created: function () {
            this.fetchData();
        },
    }
</script>
<style>

    .triggerCard {
        margin-left: 30%;
        width: 700px;
    }

    .activeTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: purple;
    }

    .dueLiveTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: green;
    }

    .expiredTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: orange;
    }
</style>